import React, {FC} from "react";
import {withFormik} from "formik";
import {t} from "i18next";
import {Button, Input, Select} from "../../commons";
import Validations from "../FormWarehouse/Validations";

interface DeliveryFormFields {
    numberDocuments: string
    dataDocuments: string
    responsible: string
    comment: string
}

interface DeliveryFormProps {
    values: DeliveryFormFields,
    touched: any,
    errors: any,
    handleChange: any,
    handleBlur: any,
    handleSubmit: any,
    toCloseModal: (e:any) => void,
}

const initialFields: DeliveryFormFields = {
    numberDocuments: '',
    dataDocuments: '',
    responsible: '',
    comment: ''
}

const InnerFormDelivery: FC<DeliveryFormProps> = ({
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        toCloseModal,
    }) => {
    const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'
    return (
        <form onSubmit={handleSubmit} className="w-full">
            <div className={"grid gap-4 grid-cols-2 mb-5"}>
                <label>
                    <div className='text-sm block text-gray-600 text-left font-medium mb-1'>Поставить на склад</div>
                    <Select></Select>
                </label>
            </div>
            <label>
                <div className='text-sm block text-gray-600 text-left font-bold mb-2'>Параметры поставки:</div>
            </label>
            <div className={"grid gap-4 grid-cols-2 "}>
                <div>
                    <Input
                        placeholder="Номер документа"
                        id="numberDocuments"
                        name="numberDocuments"
                        value={values.numberDocuments}
                        label={"Номер документа"}
                        changeHandler={handleChange}
                        customClassName={customInputClassName}
                        customLabelClassName="text-sm"
                        blurHandler={handleBlur}
                        validationError={touched.numberDocuments && errors && errors.numberDocuments && errors.numberDocuments.length > 0}
                        validationErrorDescription={touched.numberDocuments ? errors.numberDocuments : ''}
                    />
                </div>

                <div>
                    <Input
                        placeholder="Дата документа"
                        id="dataDocuments"
                        name="dataDocuments"
                        type="datetime-local"
                        value={values.dataDocuments}
                        label={"Дата документа"}
                        changeHandler={handleChange}
                        customClassName={customInputClassName}
                        customLabelClassName="text-sm"
                        blurHandler={handleBlur}
                    />
                </div>
                <div>
                    <Input
                        placeholder="Ответственный"
                        id="responsible"
                        name="responsible"
                        value={values.responsible}
                        label={"Ответственный"}
                        changeHandler={handleChange}
                        customClassName={customInputClassName}
                        customLabelClassName="text-sm"
                        blurHandler={handleBlur}
                        validationError={touched.responsible && errors && errors.responsible && errors.responsible.length > 0}
                        validationErrorDescription={touched.responsible ? errors.responsible : ''}
                    />
                </div>
                <div>
                    <Input
                        placeholder="Комментарий получателю"
                        id="comment"
                        name="comment"
                        value={values.comment}
                        label={"Комментарий получателю"}
                        changeHandler={handleChange}
                        customClassName={customInputClassName}
                        customLabelClassName="text-sm"
                        blurHandler={handleBlur}
                        validationError={touched.comment && errors && errors.comment && errors.comment.length > 0}
                        validationErrorDescription={touched.comment ? errors.comment : ''}
                    />
                </div>
            </div>

            {errors.name && touched.name && <div id="feedback">{errors.name}</div>}
            <div className="flex justify-between fixed bottom-0 border-t-[1px] px-12 w-full sm:w-1/3 sm:min-w-[511px] right-0 py-3 bg-white">
                <div>
                    <Button
                        type="button"
                        appearance="primary"
                        customClassName="mr-4"
                    >
                        {t<string>("Сохранить и добавить товары", {ns: "messages"})}
                    </Button>
                </div>
                <div>
                    <Button
                        type="button"
                        appearance="secondary"
                        customClassName="mr-4"
                        clickHandler={e => toCloseModal(e)}
                    >
                        {t<string>("Отмена", {ns: "messages"})}
                    </Button>
                    <Button
                        type="submit"
                        appearance="primary"
                        // loading={isSubmitting}
                    >
                        {t<string>("Создать", {ns: "messages"})}
                    </Button>
                </div>

            </div>
        </form>
    )
}
const FormDelivery = withFormik({
    mapPropsToValues: () => (initialFields),

    // Custom sync validation
    validate: values => {
        const errors = {};

        const validation = Validations();

        //@ts-ignore
        Object.keys(values).forEach((key) => validation[key] && validation[key](errors, values[key]))


        return errors;
    },

    handleSubmit: (values, { setSubmitting }) => {
        setTimeout(() => {
            alert(JSON.stringify(values, null, 2));
            setSubmitting(false);
        }, 1000);
    },

    displayName: 'BasicForm',
})(InnerFormDelivery);

export default FormDelivery;